import React, { useState } from "react";
import { BsSearch } from "react-icons/bs";
import { RxCross2 } from "react-icons/rx";
import Person from "./Person";
import { stripAccents } from "../utils/stripAccents";

export default function CheckboxList({
  users,
  setMembersOfGroup,
  membersOfGroup,
}) {
  const [searchTerm, setSearchTerm] = useState("");

  const handleCheckboxChange = (member) => {
    setMembersOfGroup((prevMembers) => {
      const isMemberSelected = prevMembers.some(
        (m) => m.userId === member.userId
      );
      if (isMemberSelected) {
        return prevMembers.filter((m) => m.userId !== member.userId);
      } else {
        return [...prevMembers, member];
      }
    });
  };

  const isMemberInGroup = (userId) => {
    return membersOfGroup.some((member) => member.userId === userId);
  };

  const selectedCount = membersOfGroup.length - 1; // -1 pour l'admin (user courant)

  const filteredUsers = users.filter((u) => {
    if (!searchTerm) return true;
    const term = stripAccents(searchTerm);
    return (
      stripAccents(u.prenom).includes(term) ||
      stripAccents(u.nom).includes(term) ||
      stripAccents(u.username).includes(term)
    );
  });

  return (
    <div className="col-12">
      {/* Barre de recherche */}
      <div className="form-group mb-3">
        <div className="form-control-wrap">
          <div className="form-control-icon start">
            <BsSearch />
          </div>
          <input
            type="text"
            className="form-control form-control-solid"
            placeholder="Rechercher un membre..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      </div>

      {/* Membres sélectionnés (badges) */}
      {selectedCount > 0 && (
        <div className="d-flex flex-wrap gap-2 mb-3">
          {membersOfGroup
            .filter((m) => !users.every((u) => u.userId !== m.userId) || true)
            .slice(1) // Ignorer l'admin (index 0)
            .map((m) => {
              const userInfo = users.find((u) => u.userId === m.userId);
              if (!userInfo) return null;
              return (
                <span
                  key={m.userId}
                  className="badge bg-primary d-flex align-items-center gap-1 py-2 px-3"
                  style={{ fontSize: "13px", borderRadius: "20px" }}
                >
                  {userInfo.prenom} {userInfo.nom}
                  <RxCross2
                    style={{ cursor: "pointer", marginLeft: "4px" }}
                    onClick={() => handleCheckboxChange(m)}
                  />
                </span>
              );
            })}
          <span className="badge bg-secondary py-2 px-3" style={{ fontSize: "13px", borderRadius: "20px" }}>
            {selectedCount} membre{selectedCount > 1 ? "s" : ""}
          </span>
        </div>
      )}

      {/* Liste des utilisateurs */}
      <ul
        className="list-group list-group-flush"
        style={{ maxHeight: "300px", overflowY: "auto" }}
      >
        {filteredUsers.length === 0 ? (
          <li className="list-group-item text-muted text-center">
            Aucun utilisateur trouvé
          </li>
        ) : (
          filteredUsers.map((member) => {
            const selected = isMemberInGroup(member.userId);
            return (
              <li
                key={member.userId}
                className={`list-group-item d-flex align-items-center justify-content-between py-2`}
                style={{
                  cursor: "pointer",
                  backgroundColor: selected ? "rgba(2, 86, 205, 0.08)" : "transparent",
                  transition: "background-color 0.15s",
                }}
                onClick={() => handleCheckboxChange(member)}
              >
                <div className="d-flex align-items-center gap-2">
                  <div style={{ width: "36px", height: "36px", flexShrink: 0 }}>
                    <Person
                      person={{
                        image: member.userImage || "",
                        nom: member.nom || "",
                        prenom: member.prenom || "",
                        colors: member.color,
                        userId: member.userId,
                      }}
                    />
                  </div>
                  <div>
                    <span className="fw-medium" style={{ fontSize: "14px" }}>
                      {member.prenom} {member.nom}
                    </span>
                    {member.username && (
                      <span
                        className="text-muted ms-1"
                        style={{ fontSize: "12px" }}
                      >
                        {member.username}
                      </span>
                    )}
                  </div>
                </div>
                <input
                  type="checkbox"
                  checked={selected}
                  readOnly
                  style={{
                    width: "18px",
                    height: "18px",
                    accentColor: "#0256cd",
                    cursor: "pointer",
                  }}
                />
              </li>
            );
          })
        )}
      </ul>
    </div>
  );
}
